import { z } from 'zod'

import type { RequestService } from '../request'

export function imageApiFactory(requestService: RequestService) {
  /** upload a file using the image-uploader */
  async function upload(file: File) {
    const formData = new FormData()
    formData.append('image', file)

    return await requestService.request({
      url: 'image-uploader/',
      method: 'post',
      data: formData,
      schema: z.object({ imageUrl: z.string() }),
    })
  }

  /** delete a file using the image-uploader endpoint */
  async function remove(imageUrl: string) {
    return await requestService.request({
      url: 'image-uploader/',
      method: 'delete',
      data: { imageUrl },
      schema: z.null(),
    })
  }

  return {
    upload,
    remove,
  }
}
